import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';

// ES6 class-style
class Testimonial extends PreLoginSessionCheck {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null
  }

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 3,
	 	spaceBetween: 30,
	 	loop: true,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    }
		}
    }

  	return(
  	<section className="mtb our-student">
		<div className="row">
			<div className="container">
				<h4>Our star students, placed in the best of colleges and workplaces, speak about HeyMath!</h4> 
				<Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }>
					
					<div data-ga="Home - Star Students - Shreyas Kumar" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'bRE5tit8zqU')}>
							<img src="../img/student4.jpg" alt="Shreyas Kumar, Heymath Intern from Harvey Mudd shares his journey experience"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Uday Saharia" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'KT-uJDOLOvA')}>
							<img src="../img/student5.jpg" alt="Uday Saharia, Heymath Intern from University of Chicago presents his experience"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Yamini Prashanth" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'8yKwHD8fANY')}>
							<img src="../img/student7.jpg" alt="Yamini Prashanth, Heymath user from Vidya Mandir Mylapore shares her story"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Anuradha" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'uiqV8V4f6PE')}>
							<img src="../img/student1.jpg" alt="Anuratha Rao, Heymath user from IIM Banglore shares her journey"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Rajkamal" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'wYKQM3-Yb94')}>
							<img src="../img/student2.jpg" alt="Rajkamal Ganesa, Heymath user from NIT Trichy tells his journey"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
					<div data-ga="Home - Star Students - Ramanandan Krishnamurthy" className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'-BFo63cdLSY')}>
							<img src="../img/student3.jpg" alt="Ramnandan Krishnamurthy, Heymath user from IIT Madras provides his feeback"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>					
					
					<div data-ga="Home - Star Students - Varun Ranganathan"  className="swiper-slide">
						<div className="img-box popup-youtube" onClick={this.openModal.bind(null,'MLyYoLco1eY')}>
							<img src="../img/student6.jpg" alt="Varun Ranganathan, Heymath User and Intern from SSN College shares his experience"/>
							<a><span className="play-btn"></span></a>
						</div>
					</div>
					
				</Swiper>
				<div className="slider-btns">
	        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
	        		<div className="swiper-button-next swp-next"  onClick={this.goNext}></div>
        		</div>
			</div> 
		</div>
		<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
	</section>
  	);
  }
}

export default Testimonial;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/Testimonial.js